module.exports = require('./helpers/bundle-url').getBundleURL('UT8wI') + "logo-dark.ba5147f0.svg";